import React from "react";
import {
    MdFlight,
    MdOutlineAirplaneTicket,
    MdPublic,
    MdOutlineCheckBox,
    MdQuestionMark,
} from "react-icons/md";
import { CiShoppingTag } from "react-icons/ci";
import { GrBriefcase } from "react-icons/gr";

interface SidebarProps {
    activeItem?: string;
    isCollapsed?: boolean;
    onToggleCollapse?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({
    activeItem = "Book",
    isCollapsed = false,
    onToggleCollapse,
}) => {
    const myTripsIcon = () => {
        return (
            <svg fill="none" viewBox="0 0 24 24" className="w-6">
                <path
                    fill="currentColor"
                    d="m11.954 12.958-2.573.638-1.104-.829q-.056-.04-.333-.08l-.106.04a.38.38 0 0 0-.262.22.36.36 0 0 0 .02.34l1.112 1.951q.08.14.22.199a.42.42 0 0 0 .297.007l8.467-2.24a.86.86 0 0 0 .548-.415.85.85 0 0 0 .102-.67.75.75 0 0 0-.408-.505.92.92 0 0 0-.665-.068l-2.488.67-3.764-3.53a.54.54 0 0 0-.252-.143.6.6 0 0 0-.302.003l-.115.025a.57.57 0 0 0-.425.347.56.56 0 0 0 .033.543zM4.308 19.5q-.748 0-1.278-.53a1.74 1.74 0 0 1-.53-1.278v-2.74a.71.71 0 0 1 .52-.696 2.6 2.6 0 0 0 1.068-.908Q4.5 12.747 4.5 12t-.412-1.348a2.6 2.6 0 0 0-1.069-.908.713.713 0 0 1-.52-.696v-2.74q.002-.749.53-1.278.53-.53 1.279-.53h15.384q.749 0 1.278.53.53.53.53 1.278v11.384q0 .749-.53 1.278-.53.53-1.278.53zm0-1.5h15.384a.3.3 0 0 0 .221-.087.3.3 0 0 0 .087-.22V6.307a.3.3 0 0 0-.087-.221.3.3 0 0 0-.22-.087H4.307a.3.3 0 0 0-.221.087.3.3 0 0 0-.087.22V8.55a4.1 4.1 0 0 1 1.462 1.462Q6 10.926 6 12q0 1.076-.538 1.988A4.1 4.1 0 0 1 4 15.45v2.242a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087"
                ></path>
            </svg>
        );
    };
    const checkInIcon = () => {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                className="w-6"
            >
                <path
                    fill="currentColor"
                    d="m12 22.385-6.777-5.083a1.7 1.7 0 0 1-.53-.633 1.8 1.8 0 0 1-.193-.813V4.308q0-.758.525-1.283T6.308 2.5h11.384q.758 0 1.283.525t.525 1.283v11.548q0 .427-.193.813a1.7 1.7 0 0 1-.53.633zm0-1.885 5.875-4.404a.4.4 0 0 0 .091-.11.3.3 0 0 0 .034-.14V4.308a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H6.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v11.538q0 .077.034.14a.4.4 0 0 0 .091.11zm-1.05-5.846 5.304-5.304L15.2 8.265l-4.25 4.25-2.12-2.119-1.084 1.054z"
                ></path>
            </svg>
        );
    };
    const lowFareCalendarIcon = () => {
        return (
            <svg fill="none" viewBox="0 0 24 24" className="w-6">
                <path
                    fill="currentColor"
                    d="M13.904 21.054q-.432.43-1.07.43-.637 0-1.069-.43l-8.8-8.8a1.6 1.6 0 0 1-.34-.5 1.5 1.5 0 0 1-.125-.604V4q0-.613.443-1.057A1.44 1.44 0 0 1 4 2.5h7.15q.31 0 .593.12.284.122.492.326l8.8 8.816q.44.44.445 1.076.005.635-.426 1.066zM12.83 20l7.155-7.15L11.155 4H4v7.15zM6.5 7.75q.52 0 .886-.364.365-.364.365-.885 0-.52-.364-.886A1.2 1.2 0 0 0 6.5 5.25q-.52 0-.886.364a1.2 1.2 0 0 0-.365.885q0 .52.364.886.364.365.885.365"
                ></path>
            </svg>
        );
    };
    const destinationsIcon = () => {
        return (
            <svg fill="none" viewBox="0 0 24 24" className="w-6">
                <path
                    fill="currentColor"
                    d="M12.002 21.5a9.3 9.3 0 0 1-3.705-.748 9.6 9.6 0 0 1-3.018-2.03 9.6 9.6 0 0 1-2.03-3.016 9.2 9.2 0 0 1-.749-3.704q0-1.972.748-3.705a9.6 9.6 0 0 1 2.03-3.018 9.6 9.6 0 0 1 3.016-2.03 9.2 9.2 0 0 1 3.704-.749q1.972 0 3.705.748a9.6 9.6 0 0 1 3.018 2.03 9.6 9.6 0 0 1 2.03 3.016 9.2 9.2 0 0 1 .749 3.704q0 1.972-.748 3.705a9.6 9.6 0 0 1-2.03 3.018 9.6 9.6 0 0 1-3.016 2.03 9.2 9.2 0 0 1-3.704.749M12 20q3.35 0 5.675-2.325T20 12q0-.175-.008-.358-.007-.181-.017-.327a1.84 1.84 0 0 1-.603 1.152 1.76 1.76 0 0 1-1.218.456h-2.27q-.761 0-1.303-.542a1.78 1.78 0 0 1-.542-1.303v-.922h-3.693V8.31q0-.76.543-1.305a1.77 1.77 0 0 1 1.303-.544h.923v-.385q0-.652.395-1.08.394-.428.95-.597a8 8 0 0 0-1.196-.296A7.5 7.5 0 0 0 12 4Q8.65 4 6.325 6.325T4 12v.144q0 .067.01.145h4.74q1.534 0 2.613 1.078a3.55 3.55 0 0 1 1.08 2.61v.927h-2.77v2.74q.557.174 1.137.265.578.09 1.19.091"
                ></path>
            </svg>
        );
    };
    const euroBonusIcon = () => {
        return (
            <svg fill="none" viewBox="0 0 24 24" className="w-6">
                <path
                    fill="currentColor"
                    fillRule="evenodd"
                    d="M12.31 15.5v-7h2.663q.754 0 1.253.24.503.235.75.645.253.411.252.93 0 .428-.163.731-.164.3-.438.49a1.9 1.9 0 0 1-.615.27v.068q.37.02.71.228.344.205.56.582.218.375.218.909 0 .543-.262.977-.261.43-.788.68-.526.25-1.324.25zm1.26-1.06h1.355q.687 0 .989-.263a.87.87 0 0 0 .306-.683 1.05 1.05 0 0 0-.588-.957 1.44 1.44 0 0 0-.673-.147H13.57zm0-2.963h1.247q.326 0 .587-.12a.928.928 0 0 0 .564-.878.87.87 0 0 0-.285-.67q-.282-.263-.84-.263H13.57z"
                    clip-rule="evenodd"
                ></path>
                <path
                    fill="currentColor"
                    d="M6.5 8.5v7h4.552v-1.063H7.76v-1.91h3.03v-1.064H7.76v-1.9h3.264V8.5z"
                ></path>
                <path
                    fill="currentColor"
                    fillRule="evenodd"
                    d="M4.2 4h15.6A2.2 2.2 0 0 1 22 6.2v11.6a2.2 2.2 0 0 1-2.2 2.2H4.2A2.2 2.2 0 0 1 2 17.8V6.2A2.2 2.2 0 0 1 4.2 4m0 1.5a.7.7 0 0 0-.7.7v11.6a.7.7 0 0 0 .7.7h15.6a.7.7 0 0 0 .7-.7V6.2a.7.7 0 0 0-.7-.7z"
                    clipRule="evenodd"
                ></path>
            </svg>
        );
    };
    const awardFinderIcon = () => {
        return (
            <svg fill="none" viewBox="0 0 24 24" className="w-6">
                <path
                    fill="currentColor"
                    d="M4.308 20.5q-.748 0-1.278-.53a1.74 1.74 0 0 1-.53-1.278V8.308q0-.748.53-1.278t1.278-.53H8.5V4.808q0-.748.53-1.278T10.308 3h3.384q.749 0 1.278.53.53.53.53 1.278V6.5h4.192q.749 0 1.278.53.53.53.53 1.278v10.384q0 .749-.53 1.278-.53.53-1.278.53zM10 6.5h4V4.808a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096h-3.384a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212zM6.5 8H4.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v10.384q0 .116.096.212a.3.3 0 0 0 .212.096H6.5zM16 19V8H8v11zm1.5-11v11h2.192a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V8.308a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096z"
                ></path>
            </svg>
        );
    };
    const menuItems = [
        {
            icon: React.createElement(MdFlight as any, {
                className: "text-xl rotate-45",
            }),
            text: "Book",
            isActive: activeItem === "Book",
            hasBorder: true,
        },
        {
            icon: myTripsIcon(),
            text: "My trips",
        },
        {
            icon: checkInIcon(),
            className: "text-lg",
            text: "Check in",
            hasBorder: true,
        },
        {
            icon: lowFareCalendarIcon(),
            className: "text-xl scale-x-[-1]",
            text: "Low Fare Calendar",
        },
        {
            icon: destinationsIcon(),
            className: "text-xl",
            text: "Destinations",
            hasBorder: true,
        },
        {
            icon: euroBonusIcon(),
            text: "EuroBonus",
        },
        {
            icon: awardFinderIcon(),
            className: "text-xl",
            text: "Award finder",
            hasBorder: true,
        },
        {
            icon: React.createElement(MdQuestionMark as any, {
                className: "text-xl",
            }),
            text: "Help & Info",
        },
    ];

    return (
        <>
            {/* Overlay when sidebar is expanded - only show with toggle handler */}
            {!isCollapsed && onToggleCollapse && (
                <div
                    className="fixed inset-0  z-40"
                    onClick={onToggleCollapse}
                />
            )}

            <aside
                className={`fixed left-0 top-0 h-screen bg-white z-50 shadow-md ${
                    isCollapsed ? "w-14" : "w-60"
                }`}
            >
                {/* Logo or Hamburger menu */}
                {onToggleCollapse ? (
                    <button
                        onClick={onToggleCollapse}
                        className={`flex items-center h-16 transition-colors ${
                            isCollapsed
                                ? "w-full justify-center hover:bg-[#0045ef] group"
                                : "w-full px-6 hover:bg-gray-50"
                        }`}
                        aria-label="Toggle menu"
                    >
                        <svg
                            fill="none"
                            height="24"
                            viewBox="0 0 24 24"
                            width="24"
                        >
                            <title>Menu</title>
                            <g
                                className={
                                    isCollapsed
                                        ? "stroke-sas-text group-hover:stroke-white"
                                        : "stroke-sas-text"
                                }
                                strokeLinecap="round"
                                strokeWidth="2"
                            >
                                <path d="m5 6h14"></path>
                                <path d="m5 12h14"></path>
                                <path d="m5 18h14"></path>
                            </g>
                        </svg>
                    </button>
                ) : (
                    <div className="h-10" />
                )}
                <nav>
                    <ul className={isCollapsed ? "px-0" : "px-2"}>
                        {menuItems.map((item, index) => (
                            <li
                                key={index}
                                className={
                                    item.hasBorder
                                        ? "border-b border-sas-gray-border pb-0.5"
                                        : ""
                                }
                            >
                                <button
                                    className={`
                                    w-full transition-colors
                                    flex items-center text-[15px] group rounded-lg
                                    ${
                                        isCollapsed
                                            ? "justify-center px-0 py-3"
                                            : "text-left px-3 py-3 gap-3"
                                    }
                                    ${
                                        item.isActive && !onToggleCollapse
                                            ? "bg-[#0045ef] text-white"
                                            : isCollapsed
                                            ? "text-sas-text hover:bg-[#0045ef] hover:text-white font-light"
                                            : "text-sas-text font-light hover:bg-gray-100"
                                    }
                                `}
                                    title={isCollapsed ? item.text : undefined}
                                >
                                    <span className="w-7 h-7 flex justify-center items-center flex-shrink-0">
                                        {item.icon}
                                    </span>
                                    {!isCollapsed && (
                                        <span className="text-[16px]">
                                            {item.text}
                                        </span>
                                    )}
                                </button>
                            </li>
                        ))}
                    </ul>
                </nav>
            </aside>
        </>
    );
};

export default Sidebar;
